const EmptyComponent = () => {
  return (
    <div className="w-full h-full flex justify-center items-center bg-dark">
      <span>No Data</span>
    </div>
  );
};

export default EmptyComponent;